import React, { useState, useEffect, useRef } from 'react';
import searchIcon from '../images/search-icon.svg';


const SearchBar =({ setSearchTerm })=>{

    const [state, setState] = useState('');
    const initial = useRef(true);

    useEffect(()=>{
   
        if( initial.current){
            initial.current = false;
            return
        }

        const timer = setTimeout(()=>{
            setSearchTerm(state);
        }, 500)

        return ()=> clearTimeout(timer)
    },[setSearchTerm, state])

    return (
        <div className="relative">
            <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <img className="h-5 w-5 text-gray-400" src={searchIcon} alt="search icon" />
                </div>
                <input 
                    className="block w-full pl-10 pr-3 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-xl leading-5 bg-gray-50 dark:bg-gray-700 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white focus:outline-none focus:placeholder-gray-400 dark:focus:placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm hover:shadow-md focus:shadow-lg transition-all duration-200"
                    type="text"
                    placeholder="Search by name or ID..."
                    onChange={event => setState(event.currentTarget.value)}
                    value={state}
                />
            </div>
        </div>
    )
}

export default SearchBar;